import "./ConfirmationModal.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { ConfirmationModalComponentController } from "./ConfirmationModalComponentController";

export class ConfirmationModalComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ConfirmationModalComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/ConfirmationModal/ConfirmationModal.html";
    }
}
